import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Avatar = styled.div`
  padding-right: 1rem;
`;

export const VisitorDetails = styled.div`
  align-items: center;
  display: flex;
`;

export const VisitorDetailsRightColumn = styled.div`
  margin-left: 1rem;
  
  @media only screen and (max-width: 767px) {
    max-width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const VisitorName = styled.span`
  display: block;
  font-size: 1.22rem;
  font-weight: 500;
`;

export const Host = styled.p`
  font-size: 1.2rem;
  font-weight: 400;
`;

export const Icon = styled(FontAwesomeIcon)`
  margin-right: 1rem;
`;

export const AlertIcon = styled(FontAwesomeIcon)`
  margin-left: 1rem;
`;

export const SectionHeading = styled.div`
  font-size: 1.4rem;
`;

export const Question = styled.div`
  margin: 1rem 0;
`;

export const QuestionText = styled.span`
  font-size: 1rem;
`;
